module.exports = __webpack_public_path__ + "img/logo.05779be4.png";